import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ReminderSettingEntity } from '../../domain/entities/ReminderSettingEntity'
import type { ReminderSettingAdminDto } from '@/backend/market'

export class UpdateReminderSettingModel extends ReminderSettingEntity {
  declare disabled: boolean
  declare firstDelay: number
  declare attemptDelay: number
  declare numberOfAttempts: number
  constructor(dataDto: ReminderSettingAdminDto) {
    super()
    mapEntityProperties<UpdateReminderSettingModel>(this, dataDto)
  }
}
